import {Button, Theme} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {initialFilters} from './BillingPartyPayingMembersList';


const useStyles = makeStyles((theme: Theme) => ({
    root: {},
    content: {
        padding: theme.spacing(0, 3),
        flexGrow: 1
    },
    contentSection: {
        padding: theme.spacing(2, 0)
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    fieldGroup: {
        display: 'flex',
        alignItems: 'center'
    },
    field: {
        marginTop: 0,
        marginBottom: 0
    },
    flexGrow: {
        flexGrow: 1
    },
    addButton: {
        marginLeft: theme.spacing(1)
    },
    tags: {
        marginTop: theme.spacing(1)
    },
    radioGroup: {},
    buttonIcon: {
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(3),
        '& > * + *': {
            marginTop: theme.spacing(2)
        }
    }
}));

export interface FilterValues {
    id?: number,
}

export const SearchFilter = (props: { applyFilters: (filters: FilterValues) => void, filters: FilterValues, initialFilters: FilterValues }) => {
    const {filters} = props;
    const classes = useStyles();
    const [values, setValues] = useState({...filters});

    const handleClear = () => {
        props.applyFilters(initialFilters);
    };

    const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        event.persist();

        setValues(oldValues => ({
            ...oldValues,
            [event.target.name]: event.target.type === 'checkbox' ? (event.target as HTMLInputElement).checked : event.target.value
        }));
    };

    const applyFilters = () => {
        props.applyFilters(values);
    };

    return (
        <React.Fragment>
            <div className={classes.content}>
                <div className={classes.contentSection}>
                </div>
            </div>
            <div className={classes.actions}>
                <Button id="clear" fullWidth onClick={handleClear} variant="contained">
                    <DeleteIcon className={classes.buttonIcon}/>
                    Clear
                </Button>
                <Button id="submit" color="primary" fullWidth variant="contained" onClick={applyFilters}>
                    Apply filters
                </Button>
            </div>
        </React.Fragment>
    );
};

export default SearchFilter;
